// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__KgkDK","unreadBadge":"styles_unreadBadge__1mR9f","modalContent":"styles_modalContent__2VFWC","modal":"styles_modal__11a1t"};